import React from "react";
import { baseUrl } from '../config';



const SearchBar = ({ onSearch, onSortChange }) => {
  return (
    <div className="flex justify-between items-center mb-4">
      <input
        type="text"
        placeholder="Search Influencers"
        onChange={(e) => onSearch(e.target.value)}
        className="px-4 py-2 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
      />

      <select
        onChange={(e) => onSortChange(e.target.value)}
        className="ml-4 px-4 py-2 border rounded-lg shadow-sm bg-white"
      >
        <option value="All">All</option>
        <option value="Location">Location</option>
        <option value="Followers Low to High">Followers: Low to High</option>
      </select>
    </div>
  );
};

export default SearchBar;

